import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let ProficiencyDots = class ProficiencyDots extends Vue {
};
__decorate([
    Prop(String)
], ProficiencyDots.prototype, "proficiency", void 0);
ProficiencyDots = __decorate([
    Component
], ProficiencyDots);
export default ProficiencyDots;
